<template>
  <div class="expanded-widget" :class="{ expanded: !collapsed }">
    <CollapsedWidget />
    <div class="widget-body">
      <ConversationSearch />
      <div class="conversations" v-if="conversations && conversations.length">
        <Conversation
          v-for="conversation in filteredConversations"
          :key="conversation.id"
          :conversation="conversation"
        />
        <infinite-loading
          @infinite="infiniteHandler"
          :identifier="`conversations-${conversations.length}-${conversationSearchText}`"
        >
          <div slot="no-results"></div>
          <div slot="no-more"></div>
        </infinite-loading>
      </div>
      <EmptyWidget v-else />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import InfiniteLoading from "vue-infinite-loading"
import CollapsedWidget from "./CollapsedWidget"
import ConversationSearch from "./ConversationSearch"
import Conversation from "./Conversation"

export default {
  components: {
    CollapsedWidget,
    ConversationSearch,
    InfiniteLoading,
    Conversation,
    EmptyWidget: () => import("./EmptyWidget"),
  },
  computed: {
    ...mapGetters("Message", [
      "collapsed",
      "conversationPage",
      "lastConversationPage",
      "conversations",
      "conversationSearchText",
      "loadingConversations",
      "chatUser",
    ]),
    filteredConversations () {
      return this.conversations.filter((conversation) => {
        const username = this.getConversationUsername(conversation)
        return username.includes(this.conversationSearchText)
      })
    },
  },
  methods: {
    ...mapActions("Message", ["fetchChatConversations", "fetchMoreChatConversations"]),
    getConversationUsername (conversation) {
      for (let user of conversation.users) {
        if (this.chatUser.display.name !== user.display.name) {
          return user.display.name
        }
      }
      return ""
    },
    async infiniteHandler (state) {
      if (this.loadingConversations) {
        state.complete()
        return
      }
      if (this.conversationPage >= this.lastConversationPage) {
        state.complete()
      } else {
        try {
          await this.fetchMoreChatConversations()
          state.loaded()
        } catch (error) {
          state.loaded()
        }
      }
    },

  },
  created () {
    this.fetchChatConversations()
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
$desktop-widget-right: 34rem;

.expanded-widget {
  width: 26rem;
  position: fixed;
  bottom: -50rem;
  right: $desktop-widget-right;
  max-width: 100%;
  transition: all 0.2s ease-in-out;
  @include tablet-down {
    width: 100%;
    right: 0;
    bottom: -100%;
    max-height: 100%;
  }
  &.expanded {
    bottom: 0;
  }
  .widget-body {
    height: 50rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    padding: 1rem 0 0 1rem;
    @include tablet-down {
      height: calc(100vh - 5.5rem - 5.5rem - 2px);
    }
    .conversations {
      max-height: calc(100% - 3rem);
      overflow: auto;
      overflow-x: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message_widget/ExpandedWidget.vue